import React, { useEffect } from "react";
import {
  IconInfoCircle,
  IconClock,
  IconRefresh,
  IconShield,
  IconAlertTriangle,
  IconUsers,
  IconCheck,
  IconCalendar,
} from "@tabler/icons-react";
import "../policy.css";
import PolicyContact from "../PolicyContact";
import PolicyFooter from "../PolicyFooter";

const RefundPolicyPage = () => {
  useEffect(() => {
    document.title = "Kebijakan Pembatalan & Refund | prasmul-eli";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="policy-page">
      {/* Hero */}
      <header className="policy-hero">
        <div className="policy-hero-inner">
          <h1>Kebijakan Pembatalan &amp; Refund</h1>
          <p className="policy-hero-sub">
            Berlaku efektif 1 Mei 2026 · Berlaku untuk seluruh program prasmul-eli
          </p>
        </div>
      </header>

      <main className="policy-body">
        {/* Skala refund */}
        <section className="policy-card">
          <div className="policy-card-head">
            <span className="policy-card-icon pi-amber">
              <IconInfoCircle size={22} />
            </span>
            <div>
              <h2 className="policy-card-title">Skala refund</h2>
              <p className="policy-card-subtitle">
                Berdasarkan hari kalender sebelum tanggal pelaksanaan program
              </p>
            </div>
          </div>

          <div className="refund-table-head">
            <span>Waktu Pengajuan</span>
            <span>Refund</span>
          </div>

          {[
            {
              label: (
                <>
                  <b>H-6</b>&nbsp;atau lebih awal sebelum program
                </>
              ),
              pill: "100%",
              cls: "pill-green",
            },
            {
              label: (
                <>
                  <b>H-5</b>&nbsp;sampai <b>H-3</b>&nbsp;sebelum program
                </>
              ),
              pill: "50%",
              cls: "pill-amber",
            },
            {
              label: <>H-2 sampai hari pelaksanaan</>,
              pill: "Tidak ada",
              cls: "pill-red",
            },
            {
              label: <>Setelah program dimulai</>,
              pill: "Tidak ada",
              cls: "pill-red",
            },
          ].map((row, i) => (
            <div className="refund-row" key={i}>
              <span className="refund-row-label">
                <span className="refund-dot" />
                {row.label}
              </span>
              <span className={`policy-pill ${row.cls}`}>{row.pill}</span>
            </div>
          ))}

          <div className="refund-note">
            (Perhitungan dalam hari kalender, dimulai dari tanggal pelaksanaan
            program.)
          </div>

          <div className="policy-callout callout-green">
            <p className="callout-title">
              <IconUsers size={18} /> Substitusi Peserta (Gratis)
            </p>
            <p className="callout-text">
              Anda dapat mengganti peserta tanpa biaya tambahan{" "}
              <b>paling lambat H-1 sebelum program</b>. Substitusi tidak dianggap
              sebagai pembatalan dan tidak mempengaruhi hak refund.
            </p>
            <div className="callout-subbox">
              <span className="lbl">Untuk substitusi, sertakan:</span>
              <div className="chips">
                · Nama Peserta Pengganti · Email &amp; Nomor WhatsApp · Salinan
                NIK/NPWP · Nomor Invoice
              </div>
            </div>
          </div>
          <div style={{ height: 16 }} />
        </section>

        {/* Durasi pemrosesan */}
        <section className="policy-card">
          <div className="policy-card-head bordered">
            <span className="policy-card-icon pi-green">
              <IconClock size={22} />
            </span>
            <div>
              <h2 className="policy-card-title">Durasi pemrosesan refund</h2>
              <p className="policy-card-subtitle">
                Refund dikembalikan ke metode pembayaran yang sama dengan
                pendaftaran
              </p>
            </div>
          </div>
          <div className="policy-stat">
            <span className="num">14</span>
            <span className="lbl">hari kerja maksimal</span>
            <span className="muted">(sejak pengajuan dikonfirmasi)</span>
          </div>
        </section>

        {/* Cara mengajukan refund */}
        <section className="policy-card">
          <div className="policy-card-head bordered">
            <span className="policy-card-icon pi-green">
              <IconRefresh size={22} />
            </span>
            <div>
              <h2 className="policy-card-title">Cara mengajukan refund</h2>
              <p className="policy-card-subtitle">Pilih salah satu channel berikut</p>
            </div>
          </div>

          <div style={{ height: 16 }} />
          <div className="channel-box">
            <span className="channel-num">1</span>
            <div>
              <p className="channel-title">Email</p>
              <p className="channel-text">
                Kirim ke <b>information@prasmul-eli.co</b> dengan Subjek{" "}
                <b>"Pengajuan Refund - [No. Invoice]"</b>
              </p>
            </div>
          </div>
          <div className="channel-box">
            <span className="channel-num">2</span>
            <div>
              <p className="channel-title">WhatsApp</p>
              <p className="channel-text">
                Hubungi <b>+62 811-1991-1168</b>
              </p>
            </div>
          </div>
          <div className="policy-graybox">
            <span className="lbl">Sertakan dalam pengajuan:</span>
            <span className="val">
              Nomor invoice · Nama Peserta · Alasan Pembatalan · Nomor Rekening
              Tujuan yang sama dengan pembayaran diawal
            </span>
          </div>
          <div style={{ height: 16 }} />
        </section>

        {/* Force majeure */}
        <section className="policy-card">
          <div className="policy-card-head bordered">
            <span className="policy-card-icon pi-gray">
              <IconShield size={22} />
            </span>
            <div>
              <h2 className="policy-card-title">Force majeure</h2>
              <p className="policy-card-subtitle">
                Pembatalan karena keadaan kahar oleh prasmul-eli
              </p>
            </div>
          </div>
          <div style={{ height: 16 }} />
          <p className="policy-text">
            Jika program dibatalkan/ditunda oleh prasmul-eli karena kahar
            (bencana, pandemi, regulasi pemerintah), peserta berhak atas:
          </p>
          <div className="policy-twoup">
            <div className="box">
              <IconCheck size={20} color="#1f9d57" />
              Refund 100% tanpa potongan
            </div>
            <div className="box">
              <IconCalendar size={20} color="#1565c0" />
              <span>
                Penjadwalan ulang ke <i>batch</i> berikutnya
              </span>
            </div>
          </div>
          <p className="policy-italic">
            Pilihan harus dikonfirmasi dalam 5 hari setelah pemberitahuan resmi.
          </p>
        </section>

        {/* Ketentuan khusus */}
        <section className="policy-card">
          <div className="policy-card-head bordered">
            <span className="policy-card-icon pi-red">
              <IconAlertTriangle size={22} />
            </span>
            <div>
              <h2 className="policy-card-title">Ketentuan khusus</h2>
              <p className="policy-card-subtitle">
                Kondisi yang mempengaruhi perhitungan refund
              </p>
            </div>
          </div>
          <div className="policy-bullets">
            <div className="policy-bullet">
              <span className="b-dot" />
              <span>
                <b>Reimburse Corporate</b> — Refund{" "}
                <b>hanya dikembalikan ke Nomor Rekening yang sama</b> dengan{" "}
                <b>pembayaran di awal</b>
              </span>
            </div>
          </div>
        </section>

        <PolicyContact />
      </main>

      <PolicyFooter active="refund" />
    </div>
  );
};

export default RefundPolicyPage;
